import { useState, useEffect } from 'react'

/**
 * NOTE: if stations === sortedStations, no sort has yet occurred
 */
export default function useSortedStations({
    geolocationPosition,
    stations,
    googleMaps,
}) {
    const [sortedStations, setSortedStations] = useState(stations.filter((station) => !station.onlyVisibleInTireHotel))

    useEffect(() => {
        if (!geolocationPosition || stations.length === 0 || !googleMaps) {
            return
        }
        const p0 = new googleMaps.LatLng(
            geolocationPosition.coords.latitude,
            geolocationPosition.coords.longitude
        )
        const newSortedStations = [...stations].sort(
            (a, b) => 
                googleMaps.geometry.spherical.computeDistanceBetween(
                    new googleMaps.LatLng(a.coordinatesLat, a.coordinatesLong),
                    p0
                ) -
                googleMaps.geometry.spherical.computeDistanceBetween(
                    new googleMaps.LatLng(b.coordinatesLat, b.coordinatesLong),
                    p0
                )
        )
        setSortedStations(newSortedStations)
    }, [geolocationPosition, stations, googleMaps])

    return sortedStations
}
